module.exports = __webpack_public_path__ + "img/energy5.1429e506.png";